import React from 'react';
import { useInView } from 'react-intersection-observer';

import { useWidowKiller } from '../../tools/hooks/useWidowKiller';
import PageSection from '../PageSections/PageSection';
import * as styles from './AnimatedContentCard.module.scss';
import RichTextConverter from './RichText/RichTextConverter';

export default function AnimatedContentCard({ section }) {
  const [ref, inView] = useInView({ threshold: 0.5, triggerOnce: true });
  const wrappedTitle = useWidowKiller(section.title);

  return (
    <PageSection
      wide
      noPad={true}
      className={[styles.section, section.backgroundColor ? styles[section.backgroundColor.toLowerCase()] : ''].join(
        ' '
      )}
      data-analytics-component={'animated-content-card'}
      data-analytics-id={section.title}
    >
      <div className={styles.copy} ref={ref}>
        <h2>{wrappedTitle}</h2>
        <RichTextConverter copy={section.copy} />
      </div>
      <object
        aria-label={section.mainImage.description || section.mainImage.title}
        data={section.mainImage.file.url}
        type="image/svg+xml"
        className={styles.image}
        style={{ display: inView ? 'block' : 'none' }}
      />
    </PageSection>
  );
}
